module.exports = __webpack_public_path__ + "img/BL.2f70bc92.svg";